<template>
  <div class="extendable-informations">
    <div class="extendable-informations__header">
      <InformationIcon color="primary" />
      <p>{{ title }}</p>
    </div>
    <div class="extendable-informations__content">
      <InformationIcon color="none" :filled="true" />
      <p :class="`extendable-informations__content__informations ${isExpanded ? 'expanded' : ''}`">
        {{ content }}
      </p>
      <div class="extendable-informations__content__toggle" @click="isExpanded = !isExpanded">
        {{ isExpanded ? t('ui.information.extendable.no') : t('ui.information.extendable.yes') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import InformationIcon from '@/features/ui/components/icons/information-icon.vue'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
defineProps<{
  title: string
  content: string | undefined
}>()

const isExpanded = ref(false)
</script>

<style lang="scss">
@import './extendable-informations.scss';
</style>
